import { setTerm } from './helpers';

export const setCommissionType = setTerm('commission_type');
